import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';

import Header from './Header';

class Asset extends Component {
  state = {};

  onDeleteClick = () => {
    const { asset, firestore, history } = this.props;
    firestore
      .delete({
        collection: 'assets',
        doc: asset.id,
      })
      .then(history.push('/members'));
  };
  render() {
    const { asset } = this.props;

    if (asset) {
      return (
        <div>
          <Header title={asset.name} img="/images/gallery/2013/074.jpg" />
          <div className="container">
            <p>{asset.name}</p>
            <p>{asset.desc}</p>
            <p>{asset.preview}</p>
            <Link to={`/asset/edit/${asset.id}`} className="btn btn-primary">
              Edit
            </Link>{' '}
            <button type="button" className="btn btn-danger" data-toggle="modal" data-target="#exampleModal">
              Delete
            </button>
          </div>
          <hr />
          <br />

          <hr />
          <br />
          {/* modal element */}
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Modal title
                  </h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">...</div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-dismiss="modal">
                    Close
                  </button>
                  <button type="button" onClick={this.onDeleteClick} className="btn btn-danger">
                    Delete for sure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return <p>Loading...</p>;
  }
}

export default compose(
  firestoreConnect(props => [
    {
      collection: 'assets',
      storeAs: 'asset',
      doc: props.match.params.id,
    },
  ]),
  connect(({ firestore: { ordered } }, props) => ({
    asset: ordered.asset && ordered.asset[0],
  }))
)(Asset);



// WEBPACK FOOTER //
// ./src/components/Asset.js